import React, { Component } from 'react';
import logoSvg from '../../../images/cr-logo-new.png'
import { Image } from 'react-bootstrap/lib'
import { Link } from 'react-router-dom'


class Logo extends Component {

  render() {
    return (
      <div className="Logo">
        <Link to="/">
          <Image src={logoSvg} responsive />
        </Link>
      </div>
    );
  }
}

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/Logo.js